import { render, staticRenderFns } from "./DIconSubtitle.vue?vue&type=template&id=4e67e448&scoped=true&"
import script from "./DIconSubtitle.vue?vue&type=script&lang=js&"
export * from "./DIconSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e67e448",
  null
  
)

export default component.exports